import { Fragment } from "react";
import ReactDOM from "react-dom";
import styles from "./PopUp.module.css";
const BackDrop = (props) => {
  return <section className={styles.backdrop} onClick={props.onClick}></section>;
};

const Modal = (props) => {
  let className = props.className || "";
  className = `${styles.modal} ${className}`;
  return <section className={className}>{props.children}</section>;
};

const PopUp = (props) => {
  const portalElement = document.getElementById("overlay");
  return (
    <Fragment>
      {ReactDOM.createPortal(<BackDrop onClick={props.onClick} />, portalElement)}
      {ReactDOM.createPortal(<Modal {...props} />, portalElement)}
    </Fragment>
  );
};

export default PopUp;
